// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"eb59b46e","977":"225f1a60"}[chunkId] + ".chunk.js";
};